export default __webpack_public_path__ + "static/media/Rastech-update-11.45ad0522.jpg";